import { render, staticRenderFns } from "./ui-option.vue?vue&type=template&id=c3a012da"
import script from "./ui-option.vue?vue&type=script&lang=js"
export * from "./ui-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports